
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Contact', href: '/contact' }
  ];

  return (
    <header className="bg-white shadow-lg fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/images/LOGOCENTRALDEMOLITION.png" 
              alt="Central Demolition and Services" 
              className="h-12 w-auto"
            />
            <div className="ml-4 hidden sm:block">
              <h1 className="text-2xl font-bold text-gray-900">Central Demolition</h1>
              <p className="text-sm text-gray-600">Services You Can Trust</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-lg font-medium transition-colors duration-200 hover:text-blue-600 cursor-pointer ${
                  location.pathname === item.href ? 'text-blue-600' : 'text-gray-700'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Contact Info */}
          <div className="hidden lg:flex items-center space-x-4">
            <div className="text-right">
              <a href="tel:857-777-4300" className="text-sm font-semibold text-gray-900 hover:text-blue-600 transition-colors cursor-pointer">857-777-4300</a>
              <p className="text-xs text-gray-600">Mon–Sat: 7AM–6PM</p>
              <a href="mailto:contact@central-demolition.com" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                <i className="ri-mail-line mr-1"></i>
                contact@central-demolition.com
              </a>
            </div>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden flex flex-col justify-center items-center w-8 h-8 cursor-pointer"
          >
            <span className={`bg-gray-900 h-0.5 w-6 rounded transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
            <span className={`bg-gray-900 h-0.5 w-6 rounded my-1 transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`bg-gray-900 h-0.5 w-6 rounded transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-gray-200">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block px-3 py-2 text-base font-medium transition-colors duration-200 hover:text-blue-600 cursor-pointer ${
                    location.pathname === item.href ? 'text-blue-600' : 'text-gray-700'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <div className="px-3 py-2 border-t border-gray-200 mt-4">
                <a href="tel:857-777-4300" className="text-sm font-semibold text-gray-900 hover:text-blue-600 transition-colors cursor-pointer">857-777-4300</a>
                <p className="text-xs text-gray-600">Mon–Sat: 7AM–6PM</p>
                <a href="mailto:contact@central-demolition.com" className="text-gray-600 hover:text-blue-600 transition-colors cursor-pointer">
                  <i className="ri-mail-line mr-1"></i>
                  contact@central-demolition.com
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
